/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { Panel, PANEL_STYLE } from "../../../../ui/components/Panel";
import {
	ITableColumn,
	Table,
	TableButton,
	TableCol,
	TableCommandButton,
	TableRow,
	useTable
} from "../../../../ui/components/Table";
import { TableFilter } from "../../../../ui/components/Table/TableFilter";
import { FieldText } from "../../../../ui/components/Fields/FieldText";

export interface ITestModulePrimaryPanelProps {}

const columns: ITableColumn[] = [
	{
		id: "a",
		label: "First name",
		sortable: true
	},
	{
		id: "b",
		label: "Last Name"
	},
	{
		id: "c",
		label: "City",
		sortable: true
	},
	{
		id: "d"
	}
];

const data = [
	{
		id: "60f125362c84e5369c3985ca",
		firstName: "Luann",
		surname: "Sims",
		city: "Nogal"
	},
	{
		id: "60f125363b501c02c7b84884",
		firstName: "Noble",
		surname: "Newman",
		city: "Ivanhoe"
	},
	{
		id: "60f12536cc2b0e5f34fed9cd",
		firstName: "Mercer",
		surname: "Moon",
		city: "Cumminsville"
	},
	{
		id: "60f1253601f18ff200bae5d6",
		firstName: "Marquez",
		surname: "Kim",
		city: "Verdi"
	},
	{
		id: "60f12536ce310122e4ae12bd",
		firstName: "Mable",
		surname: "Petty",
		city: "Chautauqua"
	},
	{
		id: "60f12536e82598237ca91881",
		firstName: "Vance",
		surname: "Hobbs",
		city: "Ripley"
	},
	{
		id: "60f12536cfd035ca0a837fd8",
		firstName: "Hartman",
		surname: "Bolton",
		city: "Villarreal"
	},
	{
		id: "60f12536991ba4777ea800e4",
		firstName: "Ortega",
		surname: "Griffin",
		city: "Gilmore"
	},
	{
		id: "60f125365557e2a743c263a4",
		firstName: "Norma",
		surname: "Benjamin",
		city: "Idledale"
	},
	{
		id: "60f125363ff4b1c93fe7f9d7",
		firstName: "Lela",
		surname: "Martinez",
		city: "Cartwright"
	},
	{
		id: "60f125364f9cc2b9c882bee4",
		firstName: "Best",
		surname: "Barber",
		city: "Klondike"
	},
	{
		id: "60f12536abc493d5ed66f2bc",
		firstName: "Castillo",
		surname: "Nelson",
		city: "Diaperville"
	},
	{
		id: "60f1253647099d0964341532",
		firstName: "Pickett",
		surname: "Diaz",
		city: "Edinburg"
	},
	{
		id: "60f1253691dd01401245576d",
		firstName: "Herring",
		surname: "Boyle",
		city: "Caron"
	},
	{
		id: "60f125368e15dba4c40a78ff",
		firstName: "Conley",
		surname: "Winters",
		city: "Clarksburg"
	},
	{
		id: "60f1253662e8c87787953c68",
		firstName: "Powers",
		surname: "Petersen",
		city: "Wedgewood"
	}
];

export const TestModulePrimaryPanel: FC<ITestModulePrimaryPanelProps> = () => {
	const [ tableProps ] = useTable({ columns });
	return (
		<Panel style={PANEL_STYLE.PRIMARY}>
			<Table rowSelectable {...tableProps}>
				<TableFilter>
					<TableCol>
						<FieldText value="Filter" grow />
					</TableCol>
					<TableCol colSpan={3}>
						<FieldText value="Filter" grow />
					</TableCol>
				</TableFilter>
				{data.map((item) => (
					<TableRow key={item.id} id={item.id} selectable>
						<TableCol>{item.firstName}</TableCol>
						<TableCol>{item.surname}</TableCol>
						<TableCol>{item.city}</TableCol>
						<TableCol align="right">
							<TableButton icon="mdi/delete" />
							<TableCommandButton icon="mdi/delete" />
						</TableCol>
					</TableRow>
				))}
			</Table>
		</Panel>
	);
};
